<template>
  <el-container direction="vertical" style="min-height: 100vh; min-width: 100vw !important">
    <div v-if="!publicRoute.includes(currentPath)">
      <Header class="header" />
        <el-container class="main-container">
          <el-aside width="5rem" style="background-color: #f2f2f2">
            <Sidebar />
          </el-aside>
          <!-- Main area with scrolling behavior -->
          <el-main class="main-content">
            <div class="grid justify-items-center">
              <div v-if="!isAuthenticating">
                <router-view />
              </div>
            </div>
          </el-main>
        </el-container>
    </div>
    <div v-else>
      <router-view />
    </div>
  </el-container>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';

import Sidebar from './components/layout/sidebar/Sidebar.vue';
import Header from './components/layout/Header.vue';
import { RouterView, useRoute } from 'vue-router';

import { useUserStore } from '@/stores/userStore';
import { useThemeStore } from './stores/themeStore';
import { getDomainByUrlSuffix } from './services/api/userService';

const userStore = useUserStore();
const themeStore = useThemeStore();
const isAuthenticating = ref(userStore.isAuthenticating);
const supplier = ref('');
const route = useRoute();

const publicRoute = [
  '/login',
  '/register',
  '/reset-password',
  '/forgot-password'
]
const currentPath = computed(() => route.path);

const updateSupplier = () => {
  const domain = userStore.domain;
  const supplierLoggedIn = domain?.urlSuffix;
  supplier.value = supplierLoggedIn ? supplierLoggedIn : (new URLSearchParams(window.location.search).get('supplier') as string) ?? '';
};

watch(() => userStore.domain, updateSupplier, { immediate: true });

watch(
  () => userStore.isAuthenticating,
  (newVal) => {
    isAuthenticating.value = newVal;
  }
);

watch(
  () => userStore.domain,
  (domain) => {
    const supplier = domain?.urlSuffix ?? 'aidddo';
    getDomainByUrlSuffix(supplier).then(res => {
      themeStore.setThemeFromSupplier(res.colorSchema);
    });
  },
  { immediate: true }
);

const updateGlobalStyles = () => {
    document.documentElement.style.setProperty('--color-primary', themeStore.primaryColor);
    document.documentElement.style.setProperty('--primary-text', themeStore.primaryText);
    document.documentElement.style.setProperty('--color-primary-rgb', themeStore.primaryColorRgb);
};

watch(() => themeStore.primaryColor, updateGlobalStyles, { immediate: true });

</script>

<style scoped>
.header {
  height: 7vh;
  flex-shrink: 0;
}

.main-container {
  flex: 1;
  overflow: hidden;
}

.main-content {
  height: 100vh;
  width: 100%;
  overflow-y: hidden;
}

.el-loading-spinner .path {
  stroke: black !important;
}
.el-message-box__status.el-message-box-icon--warning {
  color: black !important;
}
.el-button--primary {
  background-color: black !important;
  color: white !important;
}
.el-button--primary:hover,
.el-button--primary:focus {
  border-color: black !important;
  background-color: black !important;
}
.el-button:hover,
.el-button:focus {
  border-color: black !important;
  background-color: rgba(0, 0, 0, 0.068);
}
</style>
